import { barcodeLabelSize } from "@redotech/redo-inventory-common/barcode-label";
import {
  inventoryItemIdFormat,
  locationIdFormat,
} from "@redotech/redo-inventory-id";
import * as z from "zod";

export const generateUnknownLicensePlate = {
  name: "generateUnknownLicensePlate" as const,
  input: z.object({
    // If inventoryItemId provided, reprint for existing item
    // Otherwise, create new UNKNOWN item at locationId
    inventoryItemId: inventoryItemIdFormat.schema.optional(),
    locationId: locationIdFormat.schema.optional(),
    printerId: z.number().optional(),
    printerOptions: z.record(z.string(), z.unknown()).optional(),
    labelSize: z.enum(barcodeLabelSize).optional(),
  }),
  output: z.object({
    inventoryItemId: inventoryItemIdFormat.schema,
    pdfBase64: z.string(),
    printed: z.boolean().optional(),
  }),
};
